import { Locales } from "src/types/language";

/**
 * Определение языка версии сайта.
 *
 * Правило: ЯЗЫК ЗАДАЁТ ДОМЕН. Английская версия живёт на отдельном хосте
 * (единый бэкенд и админка — см. docs/en-version). Автоопределение по языку
 * браузера намеренно НЕ используется: пользователь ru-домена всегда видит
 * русскую версию, en-домена — английскую.
 *
 * Список EN-хостов задаётся при сборке: REACT_APP_EN_HOSTS="en.example.com,en2.example.com".
 * Дополнительно EN включается для хостов вида `en.<домен>` — чтобы версия работала
 * сразу после подключения домена, без пересборки.
 *
 * `?lang=en` / `?lang=ru` — ручной оверрайд для проверки версии до подключения
 * домена (запоминается в localStorage, сбрасывается через `?lang=ru`).
 */

const STORAGE_KEY = "locale";

const EN_HOSTS = (process.env.REACT_APP_EN_HOSTS || "")
  .split(",")
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

const isLocale = (value: string | null): value is Locales =>
  value === "ru" || value === "en";

const localeByHost = (): Locales => {
  const host = window.location.hostname.toLowerCase();
  if (EN_HOSTS.includes(host)) return "en";
  if (host.startsWith("en.")) return "en";
  return "ru";
};

export const detectLocale = (): Locales => {
  try {
    const override = new URLSearchParams(window.location.search).get("lang");
    if (isLocale(override)) {
      localStorage.setItem(STORAGE_KEY, override);
      return override;
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch {
    // приватный режим/выключенный localStorage — падаем на определение по хосту
  }
  return localeByHost();
};

/** Текущая локаль. Считается один раз за загрузку страницы. */
export const currentLocale: Locales = detectLocale();
